export enum AuthenticationStatus {
  Loading = "Loading",
  SetupMfa = "SetupMfa",
  Authenticated = "Authenticated",
  Unauthenticated = "Unauthenticated",
}
